/**
 * Group students for the Attendance roster.
 * Classrooms ordered by class_num; alphabetical within each group;
 * explicit "Unassigned" group last for blank/missing class_num.
 */
export function normalizeClassNum(value) {
  return (value == null ? '' : String(value)).trim();
}

export function groupStudentsByClass(students) {
  const byClass = new Map();
  for (const student of students || []) {
    const classNum = normalizeClassNum(student.class_num);
    const key = classNum || '__unassigned__';
    if (!byClass.has(key)) byClass.set(key, []);
    byClass.get(key).push(student);
  }

  const sortStudents = (list) =>
    [...list].sort((a, b) => {
      const ln = (a.last_name || '').localeCompare(b.last_name || '', undefined, { sensitivity: 'base' });
      if (ln !== 0) return ln;
      return (a.first_name || '').localeCompare(b.first_name || '', undefined, { sensitivity: 'base' });
    });

  const classKeys = [...byClass.keys()].filter((k) => k !== '__unassigned__').sort((a, b) =>
    a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }),
  );

  const groups = classKeys.map((key) => ({
    key,
    label: key,
    students: sortStudents(byClass.get(key)),
  }));

  if (byClass.has('__unassigned__')) {
    groups.push({
      key: '__unassigned__',
      label: 'Unassigned',
      students: sortStudents(byClass.get('__unassigned__')),
    });
  }

  return groups;
}

/** Flatten groups to a student list in display order (for pagination / mark-all). */
export function flattenGroupedStudents(groups) {
  return groups.flatMap((g) => g.students);
}
